import shouldSendSameSiteNone from "./same-site-cookie-detection";
import {
  openBodygramLogin,
  saveDataFromBodygramLocalStorage,
  formatBodygramResponse,
  GRANT_TYPE,
  REDIRECT_URI,
  SCOPE,
  BASE_AUTH_URL_STG,
  BASE_AUTH_URL_PRD,
} from "./bodygram-auth";
import { parse } from "tldts";

// 1. get query string parameters
let parameters = {};
window.location.search
  .substr(1)
  .split("&")
  .forEach((p) => {
    var q = p.split("=");
    parameters[q[0]] = q[1];
  });

if (parameters.isInlineBodygram) {
  let directEntry;
  try {
    directEntry = JSON.parse(parameters.directEntry);
  } catch (err) {
    directEntry = false;
  }
  openBodygramLogin({
    client_id: parameters.client_id,
    email: parameters.email,
    env: parameters.env,
    directEntry: directEntry,
  });
}

const isBGIframe =
  parameters.code && parameters.scope === SCOPE && parameters.state;

const Utils = (function (utils) {
  // 2. compute base domain name and default cookie options
  const cookieDomain = parse(location.hostname).domain;
  const bidKey = "virtusize.bid";
  const bidHeader = "x-vs-bid";
  const vsAuthKey = "virtusize.login";
  const vsAuthHeader = "x-vs-auth";
  const cookieTTL = 1; // in days
  const cookieExpiry = 180; // in days
  const defaultCookieOptions = {
    expires: cookieTTL,
    path: "/",
    domain: cookieDomain,
  };
  const secure = location.protocol === "https:";

  // 3. set simple cookie to ensure that we can write cookies
  utils.writeCookie = function (key, value, options) {
    if (value !== undefined && typeof value !== "function") {
      options = { expires: 1, path: "/", ...options };

      if (typeof options.expires === "number") {
        var days = options.expires,
          t = (options.expires = new Date());
        t.setDate(t.getDate() + days);
      }

      return (document.cookie = [
        encodeURIComponent(key),
        "=",
        String(value),
        options.expires ? "; expires=" + options.expires.toUTCString() : "", // use expires attribute, max-age is not supported by IE
        options.path ? "; path=" + options.path : "",
        options.domain ? "; domain=" + options.domain : "",
        shouldSendSameSiteNone(navigator.userAgent) ? "; SameSite=None" : "",
        options.secure || secure ? "; secure" : "",
      ].join(""));
    }

    return null;
  };

  // 4. parse cookies
  let cookies = {};
  document.cookie.split(";").forEach((c) => {
    var p = c.split("=");
    cookies[p[0].trim()] = p[1];
  });

  // 5. clear cookies and localStorage items from our domain not using the patterns
  utils.isValidKeyName = function (key) {
    return (
      key.startsWith("virtusize") ||
      key.startsWith("aoyama") ||
      key.startsWith("unit") ||
      key.startsWith("language")
    );
  };
  utils.cleanDomainData = function () {
    // Clean Cookies
    Object.keys(cookies).forEach(function (key) {
      if (!utils.isValidKeyName(key)) {
        utils.writeCookie(key, "", { domain: cookieDomain, expires: -1 });
        delete cookies[key];
      }
    });
    // Clean localStorage
    if (localStorage) {
      Object.keys(localStorage).forEach(function (key) {
        if (!utils.isValidKeyName(key)) {
          localStorage.removeItem(key);
        }
      });
    }
  };
  utils.cleanDomainData();

  // 6. verify that writing was succesfull - not needed anymore
  // const cookiesDisabled = !cookies["virtusize.cookies_enabled"];

  // 7. check if there is a third party bid
  let bid =
    localStorage.getItem(bidKey) || cookies[bidKey] || parameters["vs.bid"];

  // 8. check if the user is logged in
  // Get cookies first as it might be written on server side
  // TODO: Old implementation was using x-vs-auth, we should remove
  // `localStorage.getItem(vsAuthHeader)` after the 01/11/23
  let vsAuth =
    cookies[vsAuthKey] ||
    localStorage.getItem(vsAuthKey) ||
    localStorage.getItem(vsAuthHeader);
  let vsAuthFromCookie = !!cookies[vsAuthKey];

  const widgetType =
    parameters["type"] ||
    (navigator && navigator.userAgent && navigator.userAgent.match(/mobi/i)
      ? "mobile"
      : "desktop");
  const origin = decodeURIComponent(
    parameters.origin || parameters.parentOrigin || ""
  );

  if (
    typeof bid === "undefined" &&
    !isBGIframe &&
    !parameters.isInlineBodygram
  ) {
    throw new Error("Undefined bid");
  }

  utils.fetch = function (data) {
    let method = data.method || "GET";
    let url = data.url;
    if (method === "GET" && data.data) {
      url = `${url}?${data.data}`;
    }
    let request = new XMLHttpRequest();
    request.open(method, url, true);
    request.setRequestHeader(
      "Content-Type",
      `${data.contentType}; charset=UTF-8`
    );
    Object.keys(data.headers).forEach((entry) => {
      request.setRequestHeader(entry, data.headers[entry]);
    });

    request.onload = function () {
      let response = {};
      try {
        response = JSON.parse(request.responseText);
      } catch {}

      if (data.url.indexOf("bodygram") > -1) {
        response = formatBodygramResponse(response);
      }
      response.httpStatus = request.status;
      utils.postMessage(JSON.stringify(response));
    };
    request.onerror = function () {
      // 444: No Response
      utils.postMessage(JSON.stringify({ httpStatus: 444 }));
    };

    if (method === "POST" || method === "PUT") {
      let params = data.data;
      if (data.contentType !== "application/x-www-form-urlencoded") {
        params = JSON.stringify(data.data);
      }
      request.send(params);
    } else {
      request.send();
    }
  };

  utils.formatAndSendBodygramResponse = function (data) {
    if (data.scope !== SCOPE) return;
    utils.postMessage(
      JSON.stringify({
        grant_type: GRANT_TYPE,
        code: data.code,
        redirect_uri: REDIRECT_URI,
        code_verifier: localStorage.getItem("BODYGRAM_CODE_VERIFIER"),
      })
    );
    localStorage.removeItem("BODYGRAM_CODE_VERIFIER");
  };

  utils.checkLocalStorageForBGAuthCode = function () {
    const data = localStorage.getItem("bodygramAuth");
    if (data) {
      Utils.formatAndSendBodygramResponse(JSON.parse(data));
      localStorage.removeItem("bodygramAuth");
    } else {
      Utils.postMessage(JSON.stringify({ isReady: false }));
    }
  };

  utils.postEnvironmentCheck = function () {
    const event = {
      name: "util-checked-environment",
      data: {
        bid,
        vsAuth,
        vsAuthFromCookie,
        widgetType,
      },
    };
    utils.postMessage(JSON.stringify(event));
  };

  utils.postMessage = function (data) {
    if (origin) {
      parent.postMessage(data, origin);
    }
  };

  utils.setupReceiveMessage = function () {
    window.addEventListener("message", function (e) {
      if ([origin, location.origin].indexOf(e.origin) === -1) {
        return false;
      }

      if (typeof e.data !== "undefined" && e.data !== null && e.data) {
        try {
          utils.receiveMessage(JSON.parse(e.data));
        } catch (err) {
          // Silently ignoring, since it could be an IE7 or some other
          // non-modern Browser and we want to show an error message
        }
      }
    });
  };

  utils.receiveMessage = function (message) {
    let mergedOptions = { ...defaultCookieOptions, ...(message.options || {}) };
    switch (message.name) {
      case "check-environment":
        Utils.postEnvironmentCheck();
        break;
      case "integration-called-backend":
        utils.fetch(utils.formatParameters(message));
        break;
      case "bodygram-popup":
        openBodygramLogin(message.data, true);
        break;
      case "bodygram-auth-code-request":
        utils.checkLocalStorageForBGAuthCode();
        break;
      case "bodygram-auth-code-response":
        Utils.formatAndSendBodygramResponse(message.data);
        break;
      case "bodygram-auth-token": {
        const baseUrl =
          message.env === "staging" ? BASE_AUTH_URL_STG : BASE_AUTH_URL_PRD;
        const bodygramMessage = {
          method: "POST",
          contentType: "application/x-www-form-urlencoded",
          headers: {},
          url: `${baseUrl}/oauth2/token`,
          data: message.data,
        };
        utils.fetch(utils.formatParameters(bodygramMessage));
        break;
      }
      case "set-local-storage-item":
        localStorage.setItem(message.data.itemKey, message.data.itemValue);
        utils.postMessage(
          JSON.stringify({
            [message.data.itemKey]: localStorage.getItem(message.data.itemKey),
          })
        );
        break;
      case "read-local-storage-item":
        utils.postMessage(
          JSON.stringify({
            [message.data.itemKey]: localStorage.getItem(message.data.itemKey),
          })
        );
        break;
      case "remove-local-storage-item":
        localStorage.removeItem(message.data.itemKey);
        utils.postMessage(
          JSON.stringify({
            name: "remove-local-storage-item", status: "success",
          })
        );
        break;
      case "set-cookie":
        if (!message.data.itemKey.startsWith("virtusize")) {
          return;
        }
        utils.writeCookie(message.data.itemKey, message.data.itemValue, {
          ...defaultCookieOptions,
          expires: cookieExpiry,
        });
        utils.postMessage(
          JSON.stringify({ name: "set-cookie", status: "success" })
        );
        break;
      case "update-bid":
        bid = message.data.bid;
        if (utils.hasLocalStorage()) {
          localStorage.setItem(bidKey, bid);
          utils.writeCookie(bidKey, bid, {
            ...defaultCookieOptions,
            expires: cookieExpiry,
          });
        }
        utils.postMessage(JSON.stringify({ name: "update-bid", bid }));
        break;
      case "update-vs-auth":
        // Authentication Cookie set server-side is prevalent over any value
        // sent client side
        if (!vsAuthFromCookie) {
          vsAuth = message.data.vsAuth;
        }
        if (utils.hasLocalStorage()) {
          localStorage.setItem(vsAuthKey, vsAuth);
        }
        // Frontend should update to this value if it's different from the one stored
        utils.postMessage(JSON.stringify({ name: "update-vs-auth", vsAuth }));
        break;
      case "integration-reset-bid":
        bid = message.data.bid;
        if (utils.hasLocalStorage() === true) {
          // Clear all values set on our domain
          localStorage.clear();
          utils.writeCookie(bidKey, "", { domain: cookieDomain, expires: -1 });
        }
        utils.postMessage(
          JSON.stringify({ name: "integration-reset-bid", status: "success" })
        );
        break;
      case "has-storage-access":
        vsAuth = message.data.vsAuth;

        function saveAuthToken() {
          localStorage.setItem("virtusize.login", vsAuth);
          utils.writeCookie("virtusize.login", vsAuth, {
            ...defaultCookieOptions,
            expires: cookieExpiry,
          });
          utils.postMessage(
            JSON.stringify({
              name: message.name,
              status: "access",
            })
          );
        }

        if (!document.hasStorageAccess && utils.hasLocalStorage()) {
          saveAuthToken();
        } else {
          document.hasStorageAccess().then((hasAccess) => {
            if (hasAccess) {
              saveAuthToken();
            } else {
              utils.postMessage(
                JSON.stringify({
                  name: "has-storage-access",
                  status: "no-access",
                })
              );
            }
          });
        }
        break;
    }
  };

  utils.formatParameters = function (parameters) {
    return {
      method: parameters.method || "GET",
      url: parameters.url,
      dataType: "text",
      contentType: parameters.contentType || "application/json",
      type: parameters.type,
      data: utils.formatEventData(parameters),
      headers: parameters.headers || {
        [bidHeader]: bid,
        ...(vsAuth && { [vsAuthHeader]: vsAuth }),
      },
    };
  };

  utils.formatEventData = function (event) {
    if (event.method === "GET") {
      return Object.keys(event.data)
        .map((key) => key + "=" + encodeURIComponent(event.data[key]))
        .join("&");
    } else if (event.contentType === "application/json") {
      return JSON.stringify(event.data);
    } else if (event.contentType === "application/x-www-form-urlencoded") {
      return Object.keys(event.data)
        .map(
          (key) =>
            encodeURIComponent(key) + "=" + encodeURIComponent(event.data[key])
        )
        .join("&");
    }
    return event.data;
  };

  // From https://github.com/Modernizr/Modernizr/blob/master/feature-detects/storage/localstorage.js
  utils.hasLocalStorage = function () {
    var test = "vsLocalStorageTest";
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  };

  return utils;
})({});

Utils.setupReceiveMessage();
Utils.postEnvironmentCheck();

saveDataFromBodygramLocalStorage();
